/**
 * MMKAnalytics — GA4 dataLayer wrapper for Mercola Market.
 * All commerce events go through MMKAnalytics.push(event, ecommerce).
 */
(function () {
  window.dataLayer = window.dataLayer || [];

  window.MMKAnalytics = {
    push: function (eventName, ecommerce) {
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({ event: eventName, ecommerce: ecommerce });
    }
  };
})();

// =========================================================================
// Surface attribution resolver
// =========================================================================
// Returns { item_list_id } — always defined.
// Precedence:
//   1. Explicit { id } passed by caller
//   2. data-item-list attribute on clicked element (or any ancestor)
//   3. "unlabeled (<path>)" — surfaces labeling gaps in GA4 reports
window.MMKAnalytics.resolveItemList = function (opts) {
  opts = opts || {};

  if (opts.id) {
    return { item_list_id: String(opts.id) };
  }

  if (opts.fromElement && opts.fromElement.closest) {
    var wrap = opts.fromElement.closest('[data-item-list]');
    if (wrap) {
      return { item_list_id: wrap.getAttribute('data-item-list') };
    }
  }

  // Fallback — surfaces missing data-item-list labels in GA4 reports
  var path = (window.location.pathname || '').toLowerCase();
  return { item_list_id: 'unlabeled (' + path + ')' };
};

// =========================================================================
// MMKAnalytics.addToCart — JS API for non-form Add-to-Cart flows
// =========================================================================
// Use this from quick-add buttons or any other JS-triggered add-to-cart.
// For form-based add-to-cart, the global interceptor below handles it.
//
// Usage:
//   <button onclick="MMKAnalytics.addToCart({ id: 12345, quantity: 1, fromElement: this })">Add</button>
window.MMKAnalytics.addToCart = function (opts) {
  var list = window.MMKAnalytics.resolveItemList({ fromElement: opts.fromElement });

  // Do NOT include _mmk_list_id in properties — would prevent Shopify's
  // line-item merging when the same variant is added from different surfaces.
  // The list_id lives in the dispatched cart:added event only.
  var body = {
    items: [{
      id: opts.id,
      quantity: opts.quantity || 1
    }]
  };
  if (opts.properties && Object.keys(opts.properties).length) {
    body.items[0].properties = opts.properties;
  }

  return fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify(body)
  })
    .then(function (r) { return r.json(); })
    .then(function (data) {
      // Annotate items with the resolved list_id so the listener picks it up.
      var resultItems = (data.items || [data]).map(function (i) {
        return Object.assign({}, i, { _mmk_list_id: list.item_list_id });
      });
      document.dispatchEvent(new CustomEvent('cart:added', { detail: { items: resultItems } }));
      return data;
    });
};

// ---------- add_to_cart listener (Listing 5) ----------
document.addEventListener('cart:added', function (e) {
  var items = (e.detail && e.detail.items) || [];
  if (!items.length) return;

  var value = items.reduce(function (s, i) {
    return s + (Number(i.price || 0) / 100) * Number(i.quantity || 1);
  }, 0);

  MMKAnalytics.push('add_to_cart', {
    currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD',
    value: Number(value.toFixed(2)),
    items: items.map(function (i) {
      // list_id comes from the dispatched event (set by form interceptor / addToCart API)
      // OR from line.properties (when re-reading an existing cart line via /cart.js)
      var props  = i.properties || {};
      var listId = i._mmk_list_id || props._mmk_list_id || null;

      return {
        item_id:         i.sku || String(i.variant_id),
        item_name:       i.product_title || i.title,
        item_brand:      i.vendor,
        item_category:   i.product_type,
        item_variant:    i.variant_title,
        item_variant_id: String(i.variant_id),
        product_id:      String(i.product_id),
        price:           Number(i.price || 0) / 100,
        quantity:        Number(i.quantity || 1),
        item_list_id:    listId
      };
    })
  });
});

// ---------- remove_from_cart listener (Listing 6) ----------
document.addEventListener('cart:updated', function (e) {
  var change = e.detail && e.detail.change;
  if (!change || (change.type !== 'remove' && change.type !== 'decrease')) return;

  var value = change.items.reduce(function (s, i) {
    return s + (Number(i.price || 0) / 100) * Number(i.quantity || 1);
  }, 0);

  MMKAnalytics.push('remove_from_cart', {
    currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD',
    value: Number(value.toFixed(2)),
    items: change.items.map(function (i) {
      return {
        item_id:         i.sku || String(i.variant_id),
        item_name:       i.product_title || i.title,
        item_brand:      i.vendor,
        item_category:   i.product_type,
        item_variant:    i.variant_title,
        item_variant_id: String(i.variant_id),
        product_id:      String(i.product_id),
        price:           Number(i.price || 0) / 100,
        quantity:        Number(i.quantity || 1)
      };
    })
  });
});

// ---------- Global add-to-cart interceptor ----------
// Catches ANY form submission to /cart/add anywhere on the site
// (PDP main form, cart-page cross-sells, collection quick-add, etc.).
// AJAX-posts to /cart/add.js, stashes items in sessionStorage, navigates
// to /cart — the bridge then replays cart:added so add_to_cart fires.
(function globalAddToCartInterceptor () {
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    var action = (form.getAttribute('action') || '').split('?')[0];
    if (!/\/cart\/add$/i.test(action)) return;

    var submitter = e.submitter;
    if (submitter && (submitter.name === 'checkout' || submitter.value === 'checkout')) return;

    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    
    if (btn) {
      btn.disabled = true;
      btn.dataset.origText = btn.textContent;
      btn.textContent = window.location.pathname === '/es' || window.location.pathname.indexOf('/es/') === 0 ? 'Agregando…' : 'Adding…';
    }

    // Resolve surface attribution. We DO NOT persist _mmk_list_id as a Shopify
    // line property, because differing list_id values would prevent Shopify
    // from merging duplicate adds of the same variant (Shopify merges only
    // when variant_id AND properties match exactly). Instead we annotate the
    // items in memory below so the cart:added listener sees the list_id —
    // GA4 only needs it at the moment of the event, not persisted on the line.
    var list = window.MMKAnalytics.resolveItemList({ fromElement: form });
    var formData = new FormData(form);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    })
    .then(function (res) {
      if (!res.ok) return res.json().then(function (err) { throw err; });
      return res.json();
    })
    .then(function (data) {
      var items = data.items || [data];
      // Annotate items with the resolved list_id client-side. The list_id is
      // NOT persisted on the cart line (see comment above) — this annotation
      // only lives in the dispatched cart:added event so GA4 add_to_cart gets it.
      items = items.map(function (i) {
        return Object.assign({}, i, { _mmk_list_id: list.item_list_id });
      });

      try { sessionStorage.setItem('mmk_pending_add_to_cart', JSON.stringify(items)); } catch (e) {}
      window.location.href = (window.routes && window.routes.cart_url) || '/cart';
    })
    .catch(function (err) {
      if (btn) {
        btn.disabled = false;
        btn.textContent = btn.dataset.origText || 'Add to Cart';
      }
      console.error('[mmk] cart add failed:', err);
      alert((err && err.description) || 'Could not add to cart. Please try again.');
    });
  });
})();

// ---------- /cart page interceptor: dispatch cart:updated on qty/remove ----------
// Converts standard cart form posts and remove links to AJAX, computes the diff
// (before vs after via /cart.js), dispatches cart:updated for each change type.
(function cartPageInterceptor () {
  // Run only on /cart (handles locale prefixes like /en-us/cart too)
  var path = window.location.pathname.replace(/\/$/, '');
  if (path.split('/').pop() !== 'cart') return;

  function fetchCart () {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function indexByKey (items) {
    var m = {};
    items.forEach(function (i) { m[i.key] = i; });
    return m;
  }

  function computeChanges (before, after) {
    var changes = { remove: [], decrease: [], increase: [] };
    var beforeMap = indexByKey(before.items);
    var afterMap  = indexByKey(after.items);

    before.items.forEach(function (b) {
      var a = afterMap[b.key];
      if (!a) {
        changes.remove.push(Object.assign({}, b));
      } else if (a.quantity < b.quantity) {
        var d = Object.assign({}, b);
        d.quantity = b.quantity - a.quantity;
        changes.decrease.push(d);
      }
    });

    after.items.forEach(function (a) {
      var b = beforeMap[a.key];
      if (!b) {
        changes.increase.push(Object.assign({}, a));
      } else if (a.quantity > b.quantity) {
        var d = Object.assign({}, a);
        d.quantity = a.quantity - b.quantity;
        changes.increase.push(d);
      }
    });

    return changes;
  }

  function persistChanges (changes) {
    try {
      var existing = JSON.parse(sessionStorage.getItem('mmk_pending_cart_updates') || '[]');
      ['remove', 'decrease', 'increase'].forEach(function (type) {
        if (changes[type] && changes[type].length) {
          existing.push({ type: type, items: changes[type] });
        }
      });
      sessionStorage.setItem('mmk_pending_cart_updates', JSON.stringify(existing));
    } catch (e) { /* ignore */ }
  }

  function ajaxAndReload (performRequest) {
    fetchCart().then(function (before) {
      return performRequest().then(function (after) {
        persistChanges(computeChanges(before, after));
        window.location.reload();
      });
    }).catch(function (err) {
      console.error('[mmk] cart change failed:', err);
      window.location.reload();
    });
  }

  // (a) Intercept form submits to /cart or /cart/update (qty updates, "Update cart" button)
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    var action = (form.getAttribute('action') || '').split('?')[0];
    if (/\/cart\/add$/i.test(action)) return;            // PDP form, handled elsewhere
    if (!/\/cart$|\/cart\/update$/i.test(action)) return; // not a cart-update form
console.log('global addtocart sumbit!!! SHOULD NOT FIRE');
    var submitter = e.submitter || form.querySelector('button[name="checkout"]:focus, [type="submit"][name="checkout"]:focus');
    if (submitter && (submitter.name === 'checkout' || submitter.value === 'checkout')) return;

    e.preventDefault();
    var formData = new FormData(form);

    ajaxAndReload(function () {
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      }).then(function (r) { return r.json(); });
    });
  });

  // (b) Intercept remove/change links: <a href="/cart/change?line=2&quantity=0">
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a');
    if (!a) return;
    var href = a.getAttribute('href') || '';
    if (!/\/cart\/(change|update)(\?|$)/i.test(href)) return;

    e.preventDefault();
    var url  = new URL(a.href, window.location.origin);
    var body = {};
    url.searchParams.forEach(function (v, k) {
      var n = Number(v);
      body[k] = (v === '' || isNaN(n)) ? v : n;
    });

    ajaxAndReload(function () {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Accept':           'application/json',
          'Content-Type':     'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(body)
      }).then(function (r) { return r.json(); });
    });
  });
})();

// ---------- Bridge: replay sessionStorage events after navigation ----------
(function () {
  function flush () {
    // add_to_cart bridge (PDP → /cart navigation)
    try {
      var raw = sessionStorage.getItem('mmk_pending_add_to_cart');
      if (raw) {
        sessionStorage.removeItem('mmk_pending_add_to_cart');
        var items = JSON.parse(raw);
        if (items && items.length) {
          console.log('bridge fires');
          console.log(items);
          document.dispatchEvent(new CustomEvent('cart:added', { detail: { items: items } }));
        }
      }
    } catch (e) {}

    // cart:updated bridge (/cart reloads after AJAX update)
    try {
      var rawU = sessionStorage.getItem('mmk_pending_cart_updates');
      if (rawU) {
        sessionStorage.removeItem('mmk_pending_cart_updates');
        var updates = JSON.parse(rawU);
        if (Array.isArray(updates)) {
          updates.forEach(function (change) {
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { change: change } }));
          });
        }
      }
    } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', flush);
  } else {
    flush();
  }
})();

// ---------- view_cart (page load + drawer open) ----------
(function () {
  function fireViewCart (cart) {
    if (!cart || !cart.items || !cart.items.length) return; // skip empty cart

    MMKAnalytics.push('view_cart', {
      currency: cart.currency,
      value:    Number((cart.total_price / 100).toFixed(2)),
      items: cart.items.map(function (i) {
        return {
          item_id:         i.sku || String(i.variant_id),
          item_name:       i.product_title || i.title,
          item_brand:      i.vendor,
          item_category:   i.product_type,
          item_variant:    i.variant_title,
          item_variant_id: String(i.variant_id),
          product_id:      String(i.product_id),
          price:           Number(i.final_price || i.price || 0) / 100,
          quantity:        Number(i.quantity || 1)
        };
      })
    });
  }

  function loadAndFire () {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(fireViewCart)
      .catch(function (err) { console.error('[mmk] view_cart fetch failed:', err); });
  }

  // (a) /cart page load fire
  var path = window.location.pathname.replace(/\/$/, '');
  if (path.split('/').pop() === 'cart') {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', loadAndFire);
    } else {
      loadAndFire();
    }
  }

  // (b) Cart-drawer-opened fire (Listing 7) — fires whenever a future drawer dispatches this event
  document.addEventListener('cart-drawer:opened', loadAndFire);
})();
